import React from 'react';

import { MakeAndModel } from 'Components/MakeAndModel';
import { VehicleSummary } from 'Components/VehicleSummary';

import { VrmSection } from './VrmSection/VrmSection';
import { useVehicleMainInfo } from './useVehicleMainInfo';

import styles from './MainInfoSection.module.scss';

export const MainInfoSection: React.FC = () => {
	const { fuel, make, mileage, model, transmission, year } = useVehicleMainInfo();
	return (
		<div className={styles.container}>
			<VrmSection />
			<MakeAndModel make={make} model={model} />
			<VehicleSummary fuel={fuel} mileage={mileage} transmission={transmission} year={year} />
		</div>
	);
};
